import {Button, Heading, Text, VStack} from "@chakra-ui/react";
import React from "react";
import {useNavigate} from "react-router-dom";
import { PAYMENT_METHOD_NAME_BANK_TRANSFER, PAYMENT_METHOD_NAME_CARD, PAYMENT_METHOD_NAME_MERCADO_PAGO, PAYMENT_PAGE } from '../constants';
import { MemberProductStatus } from '../models/periodic-product-payment';

interface Props {
  productsToPayList: MemberProductStatus[];
  description?: string;
}

const DEFAULT_DESCRIPTION =
  'Podés abonar tus cuotas sociales pendientes de pago a través de los siguientes medios de pago. Es rápido, simple y seguro.';

export default function PaymentMethods(props: Props) {
  const navigate = useNavigate();
  const description = props.description ?? DEFAULT_DESCRIPTION;

  const handleCardsPayment = (): void => {
    navigate(PAYMENT_PAGE, {
      state: { productsToPay: props.productsToPayList, paymentMethod: PAYMENT_METHOD_NAME_CARD }
    });
  };

  const handleMercadoPagoButton = (): void => {
    navigate(PAYMENT_PAGE, {
      state: { productsToPay: props.productsToPayList, paymentMethod: PAYMENT_METHOD_NAME_MERCADO_PAGO }
    });
  };

  const handleBankTransferButton = (): void => {
    navigate(PAYMENT_PAGE, {
      state: { productsToPay: props.productsToPayList, paymentMethod: PAYMENT_METHOD_NAME_BANK_TRANSFER }
    });
  };

  return (
    <VStack alignItems="flex-start">
      <Heading as="h2" size="md">
        Métodos de pago
      </Heading>
      <Text>{description}</Text>
      <VStack marginTop={3} paddingTop={3} alignItems="flex-start">
        <Button colorScheme="blue" onClick={handleCardsPayment}>
          Tarjetas
        </Button>
        <Button colorScheme="blue" onClick={handleMercadoPagoButton}>
          MercadoPago
        </Button>
        <Button colorScheme="blue" onClick={handleBankTransferButton}>
          Transferencia bancaria
        </Button>
      </VStack>
    </VStack>
  );
}
